export default __webpack_public_path__ + "static/vault-payment-methods-8c51f8a168badb13ac6f6feb8a05041f.png";